import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import SaveIcon from '@material-ui/icons/GetApp';
import classNames from 'classnames';
import {settings} from '../config/config'

const styles = theme => ({
  icon: {
    marginRight: theme.spacing.unit * 2
  }
});

class resultTable extends Component {

  convert(time){
    const date = new Date(time*1000),
    year = date.getFullYear(),
    month = date.getMonth() + 1,
    day = date.getDate(),
    hours = date.getHours(),
    minutes = "0" + date.getMinutes(),
    seconds = "0" + date.getSeconds(),
    formatted = year + "/" + month + "/" + day + " " + hours + ':' + minutes.substr(-2) + ':' + seconds.substr(-2);
    return formatted;
  }

  render() {
    const {classes} = this.props;
    if (this.props.results.data.length === 0) {
      return (null);
    }
    return (<div className="scroll">
      <Table className={classes.table}>
        <TableHead>
          <TableRow>
            <TableCell>Download</TableCell>
            <TableCell>ファイル名</TableCell>
            <TableCell>ユーザー数</TableCell>
            <TableCell>クエリ</TableCell>
            <TableCell>作成日時</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>{
            this.props.results.data.map(row => (<TableRow key={row.filename + row.param + row.date}>
              <TableCell align="right">
                <a href={settings.download + row.filename}>
                  <Button variant="contained" size="large" color="primary" className={classes.button}>
                    <SaveIcon className={classNames(classes.leftIcon, classes.iconSmall)} style={{
                        marginRight: "5px"
                      }}/>
                  </Button>
                </a>
              </TableCell>
              <TableCell align="left">{row.filename}</TableCell>
              <TableCell align="left">{row.sum}</TableCell>
              <TableCell align="left">{row.param}</TableCell>
              <TableCell align="left">{this.convert(row.date)}</TableCell>
            </TableRow>))
          }</TableBody>
      </Table>
    </div>)
  }
}

resultTable.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(resultTable);
